/* eslint-disable no-useless-escape */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';
import '../../assets/css/bookNow.css';

import Fade from 'react-reveal/Fade';
import * as emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from '../partials/DatePicker';


export default function (props) {
  const { data, resetForm } = props;
  let dateData = "20222, 06, 18, 0, 0";

  const getDataD = (obj) => {
    dateData = obj;
  }

  const submitEmail = () => {
    const {
      dateData, name, email, phone, rooms, bathrooms, category, date
    } = data;

    const templateParams = {
      from_name: `( ${email} - ${category} )`,
      to_name: 'Signature Move',
      message: `Name: ${name}, Phone: ${phone}.\n\nRooms Rquested: ${rooms}. Bathrooms Requested: ${bathrooms}. Type: ${category}.
       \n\n Move In Date: ${date}  `,
    };

    if ((dateData.startDay !== 0 || dateData.endDay !== 0) && email !== '') {
      emailjs.send(
        'service_m9ez6le',
        'template_8b22j2g',
        templateParams,
        'user_Jmss4bRHKILhJ0KTp7Zxf',
      )
        .then(() => {
          toast.success('Success! we\'\ll get back to you soon. Thank you!');
          resetForm();
        }, (error) => {
          toast.error(error);
        });
    } else {
      console.log(dateData)

      toast.error('Please fill out the blank form.');
    }
  };


  return (
    <>
      <Fade bottom>
        <div className="pickRooms">

          <div className="selectInputs">
            <div className='wrappingUp'>
              <p>Email:</p>
              <input className='inputText' id="email" name="email" type="email" placeholder="Your email address"
                value={data.email} onChange={props.onChange} required />
            </div>
            <div className="wrappingUp">
              <p>Name:</p>
              <input className='inputText' id="name" name="name" type="name" placeholder="Your Name"
                value={data.name} onChange={props.onChange} required />
            </div>
            <div class="wrappingUp">
            <p>Phone Number:</p>
            <input className='inputText' id='phone' type="text" name="phone" placeholder="Your Phone Number" value={data.phone} onChange={props.onChange} required />
            </div>
          </div>
          <div className='selectInputs'>
            <div className='wrappingUp'>
              <p>Rooms:</p>
              <select id='rooms' name='rooms' value={data.rooms} onChange={props.onChange}>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
                <option value='5'>5</option>
                <option value='6'>6</option>

              </select>
            </div>
            <div className='wrappingUp'>
              <p>Bathrooms:</p>
              <select id='bathrooms' name='bathrooms' value={data.bathrooms} onChange={props.onChange}>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
                <option value='5'>5</option>
                <option value='6'>6</option>

              </select>
            </div>
            <div className='wrappingUp'>
              <p>Category:</p>
              <select id="category" name='category' value={data.category} onChange={props.onChange}>
              <option value='new build'>New Build</option>
              <option value='build on property'>Build on Property</option>
              <option value='home remodel'>Home Remodel</option>
                <option value='studio residence'>Studio Residence</option>
                <option value='one bed residence'>One-bedroom Residence</option>
                <option value='two bed residence'>Two-bedrooms Residence</option>
                <option value='three bed residence'>Three-bedrooms Residence</option>
                <option value='royal suit'>Royal Suite</option>
              </select>
            </div>
            <div className='calendar'>
              <p>Propose construction date:</p>
              <input className='inputText' id="date" name="date" type="date"
                value={data.date} onChange={props.onChange} required />
              {/* <DatePicker id="dateData" value={data.dateData} onChange={props.onChange} name="dateData" dataD={getDataD} /> */}
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button

              className="btnStyle btnActive"
              type="button"
              onClick={submitEmail}
            >
              Submit
            </button>
          </div>
        </div>
      </Fade><ToastContainer />
    </>

  );
}

